var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostcard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9058 11.9998C0.945799 11.8304 0.541093 11.341 0.45874 11.1175L7.16462 4.97632H10.3764L17.6823 11.1175C17.5693 11.5975 16.8117 11.9057 16.447 11.9998H1.9058Z",
    fill: "#F46767"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08213 5.92941L0.493896 0.811765C1.02331 0.105882 1.61154 0 2.15272 0H16.4115C17.1174 0.0847059 17.5527 0.576471 17.6821 0.811765L10.0586 5.92941C9.29625 6.49412 8.42331 6.16471 8.08213 5.92941Z",
    fill: "#6DADFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7646 5.4353L17.6117 11.1529C17.9505 11.1529 18.1294 10.4 18.1764 10.0235V1.90589C18.1764 1.36941 17.8705 0.952944 17.6823 0.811768L10.7646 5.4353Z",
    fill: "#5895DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34131 5.43544L0.564837 11.1531C0.226014 11.1531 0.0471907 10.4001 0.000131607 10.0237V1.90602C0.000131607 1.36955 0.306014 0.917788 0.494249 0.776611L7.34131 5.43544Z",
    fill: "#5895DF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostcard);
export default __webpack_public_path__ + "static/media/postcard.90913e09d375d5dcf57fbc5ac4cab504.svg";
export { ForwardRef as ReactComponent };